import React, { useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { Document as DocxDocument, Packer, Paragraph, HeadingLevel } from "docx";
import "../Reports.css";

function AllOperationsReport() {
    const [operations, setOperations] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleGenerateReport = async () => {
        setLoading(true);
        try {
            const response = await axios.get("https://monitor.dev.masiot.dmsolution.ru/api/v1/reports/allOperations", {
                responseType: 'arraybuffer'
            });

            const decoder = new TextDecoder('utf-8');
            const decodedData = decoder.decode(new Uint8Array(response.data));

            const operationsData = decodedData.split("\n\n")
                .filter(operation => operation.trim() !== "")
                .map(operation => {
                    const [operationId, orderNumber, operationNumber, timeStart, length, timeEnd, quantity, location, status, agentId, WFId] = operation.split("\n").map(line => line.split(": ")[1]);
                    return {
                        operationId,
                        orderNumber,
                        operationNumber,
                        timeStart,
                        length,
                        timeEnd,
                        quantity,
                        location,
                        status,
                        agentId,
                        WFId
                    };
                });
            setOperations(operationsData);
        } catch (error) {
            console.error("Ошибка при получении данных:", error);
        } finally {
            setLoading(false);
        }
    };

    const generateWordDocument = () => {
        const doc = new DocxDocument({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            text: "Отчет по всем операциям",
                            heading: HeadingLevel.HEADING_1,
                            spacing: { after: 300 },
                        }),
                        ...operations.flatMap((operation, index) => [
                            new Paragraph({
                                text: `Операция #${index + 1}`,
                                heading: HeadingLevel.HEADING_2,
                                spacing: { after: 100 },
                            }),
                            new Paragraph({ text: `Идентификатор операции: ${operation.operationId}` }),
                            new Paragraph({ text: `Номер заказа: ${operation.orderNumber}` }),
                            new Paragraph({ text: `Номер операции: ${operation.operationNumber}` }),
                            new Paragraph({ text: `Время начала: ${operation.timeStart}` }),
                            new Paragraph({ text: `Длина операции (мин): ${operation.length}` }),
                            new Paragraph({ text: `Время окончания: ${operation.timeEnd || "Не завершено"}` }),
                            new Paragraph({ text: `Количество: ${operation.quantity}` }),
                            new Paragraph({ text: `Местоположение: ${operation.location}` }),
                            new Paragraph({ text: `Статус: ${operation.status}` }),
                            new Paragraph({ text: `Идентификатор агента: ${operation.agentId}` }),
                            new Paragraph({ text: `WFId: ${operation.WFId}` }),
                            new Paragraph({ text: "-----------------------------", spacing: { before: 200, after: 200 } }),
                        ])
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "all_operations_report.docx");
        });
    };

    return (
        <div className="otch-report-card">
            <h2>⚙️ Все операции</h2>

            {operations.length > 0 && (
                <div className="otch-result-container">
                    <p className="otch-result-text">
                        Найдено операций: <span className="otch-highlight">{operations.length}</span>
                    </p>
                </div>
            )}

            <div className="otch-button-container">
                <button
                    onClick={handleGenerateReport}
                    disabled={loading}
                    className={`otch-button otch-generate-btn ${loading ? 'loading' : ''}`}
                >
                    {loading ? (
                        <>
                            <span className="otch-spinner"></span>
                            Загрузка...
                        </>
                    ) : (
                        "📊 Получить все операции"
                    )}
                </button>
                {operations.length > 0 && (
                    <button
                        onClick={generateWordDocument}
                        className="otch-button otch-word-download-btn"
                    >
                        📥 Скачать отчет
                    </button>
                )}
            </div>
        </div>
    );
}

export default AllOperationsReport;